import common from '@/store/common/mutations';
import * as types from './mutation-types';
import { SEARCH_PARAMS, GROUPS, MASTER_INFO } from './state';
export default {
	...common,
	[types.STATE_INIT]: state => {
		state.authCode = '';
		state.searchParams = SEARCH_PARAMS();
		state.masterInfo = MASTER_INFO();
		state.groups = GROUPS();
		state.partCost = [];
		state.gridList = [];
		state.tymaCdList = [];
	},
	[types.STATE_CLEAR]: state => {
		state.masterInfo = MASTER_INFO();
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.GROUPS]: (state, { key, value }) => {
		state.groups[key] = value;
	},
	[types.MASTER_INFO]: (state, { key, value }) => {
		state.masterInfo[key] = value;
	},
	[types.SEARCH_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.masterInfo = MASTER_INFO();
	}
};
